export default __webpack_public_path__ + "static/media/ChampionsPlus_2025.8adc6288.jpg";